import { HttpStatusCode } from "@/constants/http-status-code.enum";

export default class PermissionDeniedError extends Error {
  public readonly statusCode: number;

  constructor(message: string) {
    super(message);
    this.name = "PermissionDeniedError";
    this.statusCode = HttpStatusCode.Forbidden;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, PermissionDeniedError);
    }
  }

  toJSON() {
    return {
      error: this.name,
      message: this.message,
      statusCode: this.statusCode,
    };
  }
}
